/*
 * @Descripttion: 
 * @version: 0.1.0
 * @Author: wangcan
 * @Date: 2023-03-29 11:36:05
 * @LastEditors: wangcan
 * @LastEditTime: 2023-04-03 09:38:50
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/apply-detail',
  },
  {
    path: '/apply-detail',
    name: 'ApplyCompany',
    component: () => import('../views/apply-company.vue')
  },
  {
    path: '/apply-post',
    name: 'ApplyPost',
    component: () => import('../views/apply-post.vue')
  },
  {
    path: '/send-add-mobile',
    name: 'sendAddMobile',
    component: () => import('../views/send-add-mobile.vue')
  },
  {
    path: '/post-detail',
    name: 'postDetail',
    component: () => import('../views/post-detail.vue')
  },
  // {
  //   path: '/submited',
  //   name: 'submited',
  //   component: () => import('../views/submited.vue')
  // },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
